// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ChangeDocumentTypeModal_buttonWrapper__b6e7z"};